import { render, staticRenderFns } from "./PainelProjetosEAcoes.vue?vue&type=template&id=63653f80"
import script from "./PainelProjetosEAcoes.vue?vue&type=script&lang=js"
export * from "./PainelProjetosEAcoes.vue?vue&type=script&lang=js"
import style0 from "./PainelProjetosEAcoes.vue?vue&type=style&index=0&id=63653f80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports